// Indício de sessão OIDC (só um marcador booleano em sessionStorage — nunca tokens, Parte 3.5): sem ele a SPA não gasta
// a renovação silenciosa (iframe `prompt=none`) numa primeira visita; com ele restaura a sessão após um recarregamento.
export const SESSION_HINT_STORAGE_KEY = 'giyus.auth.session-hint';

export type HintStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export function browserHintStorage(): HintStorage | null {
  return typeof sessionStorage === 'undefined' ? null : sessionStorage;
}

export function hasSessionHint(storage: HintStorage | null | undefined): boolean {
  try {
    return storage?.getItem(SESSION_HINT_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setSessionHint(storage: HintStorage | null | undefined, present: boolean): void {
  try {
    if (present) {
      storage?.setItem(SESSION_HINT_STORAGE_KEY, '1');
    } else {
      storage?.removeItem(SESSION_HINT_STORAGE_KEY);
    }
  } catch {
    // armazenamento indisponível (modo privado): apenas custa uma renovação silenciosa a mais
  }
}
